import { customizeCraftJsComponent } from '../../helpers';
import { EditorInput } from '../EditorInput';

export const EditorLoginUrlInput = customizeCraftJsComponent(EditorInput, {
	name: 'Login URL Input',
	props: {
		name: 'idpURL',
		type: 'url',
		placeholder: 'Login URL',
		label: 'Login URL',
		'data-errormessage-pattern-mismatch': 'Must be a valid URL'
	}
});
